import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

export function useGetAccountVelocityMemberships(accountId: string) {
  return useQuery({
    queryKey: usersQueryKeys.velocityMembershipList(accountId),
    queryFn: ({ signal }) => UsersService.getAccountVelocityMemberships(accountId, { signal }),
    enabled: Boolean(accountId),
  });
}
